import React, { createContext, useContext, useState, useEffect } from 'react';
import { db } from '../firebase/firebase';
import { collection, onSnapshot, query, where, orderBy } from 'firebase/firestore'; 
import { useSelector, useDispatch } from 'react-redux'; 
import { selectIsLoggedIn, selectUserID } from '../redux/slice/authSlice';
import { SET_TASKS } from '../redux/slice/taskSlice'; 

const TaskContext = createContext();

export { TaskContext };

export const TaskProvider = ({ children }) => {
  
  const [loadingTasksFromFirestore, setLoadingTasksFromFirestore] = useState(true); 

  const isLoggedIn = useSelector(selectIsLoggedIn);
  const userID = useSelector(selectUserID);
  const dispatch = useDispatch(); 

  useEffect(() => {
    let unsubscribe;

    if (isLoggedIn && userID) {
      setLoadingTasksFromFirestore(true);
      const tasksCollectionRef = collection(db, 'tasks');
       const userTasksQuery = query(
        tasksCollectionRef,
        where("userId", "==", userID),
        orderBy("createdAt", "desc") 
      );

      unsubscribe = onSnapshot(userTasksQuery,
        (snapshot) => {
          const tasksData = snapshot.docs.map((doc) => ({
            id: doc.id,
            ...doc.data()
          }));
          dispatch(SET_TASKS(tasksData)); 
          setLoadingTasksFromFirestore(false);
        },
        (error) => {
          console.error("Error fetching tasks from Firestore:", error);
         
          setLoadingTasksFromFirestore(false);
        
        }
      );
    } else {
     
      dispatch(SET_TASKS([]));
      setLoadingTasksFromFirestore(false);
      if (unsubscribe) {
        unsubscribe();
      }
    }

    return () => {
      if (unsubscribe) {
        unsubscribe();
      }
    };
  }, [isLoggedIn, userID, dispatch]); 

  return (
    <TaskContext.Provider value={{ loadingTasksFromFirestore }}>
      {children}
    </TaskContext.Provider>
  );
};


export const useTasks = () => {
  return useContext(TaskContext); 
};
